<div>
    <div style="display: block">
        <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions">
        </canvas>
    </div>
</div>